import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { IconButton, Stack, Typography } from "@mui/material";
import { ToolbarProps } from "react-big-calendar";
import { useTranslation } from "react-i18next";
import { RoundedButton } from "../../../../common/components/styled/styled";
import { CalendarEvent } from "../types";

export const CalendarToolbar = (props: ToolbarProps<CalendarEvent, object>) => {
  const { t } = useTranslation("talentProfile");
  const { label, onNavigate } = props;

  return (
    <Stack
      id="talent-calendar-toolbar"
      direction="row"
      alignItems="center"
      bgcolor="background.paper"
      sx={{
        width: "100%",
        p: 2,
        borderTopLeftRadius: "10px",
        borderTopRightRadius: "10px",
        borderBottomLeftRadius: "0",
        borderBottomRightRadius: "0",
        overflow: "hidden",
        border: (theme) => `1px solid ${theme.palette.divider}`,
        borderBottom: "none",
        boxSizing: "border-box",
      }}
    >
      <Stack direction="row" gap={1} alignItems="center">
        <RoundedButton
          id="calendar-today-button"
          variant="contained"
          onClick={() => onNavigate("TODAY")}
        >
          {t("calendar.today")}
        </RoundedButton>

        <IconButton
          id="calendar-prev-button"
          onClick={() => onNavigate("PREV")}
          size="small"
        >
          <ChevronLeft />
        </IconButton>
        <Typography
          id="calendar-month-label"
          variant="header"
          fontWeight={700}
          fontSize="22px"
          minWidth="165px"
          textAlign="center"
        >
          {label}
        </Typography>
        <IconButton
          id="calendar-next-button"
          onClick={() => onNavigate("NEXT")}
          size="small"
        >
          <ChevronRight />
        </IconButton>
      </Stack>
    </Stack>
  );
};
